import PropTypes from 'prop-types';
import { colorPropTypes } from '../utils/color_prop';
var CheckedStringPropType = ['checked', 'false', 'indeterminated', 'true', 'unchecked'];
var CheckedTypePropType = PropTypes.oneOfType([PropTypes.bool, PropTypes.oneOf([...CheckedStringPropType, PropTypes.bool])]);
var propTypes = {
  checked: CheckedTypePropType,
  className: PropTypes.string,
  color: PropTypes.oneOfType([PropTypes.oneOf(colorPropTypes), PropTypes.string]),
  customStyle: PropTypes.any,
  defaultChecked: CheckedTypePropType,
  disabled: PropTypes.bool,
  icon: PropTypes.element,
  id: PropTypes.string,
  label: PropTypes.node,
  name: PropTypes.string,
  onChange: PropTypes.func,
  value: PropTypes.oneOfType([PropTypes.number, PropTypes.string])
};
export default propTypes;